// get data from external database and save to store

import { mapGetters } from "vuex";
import getData from "@/globals/mixins/getData.js";

export default {
  data() {
    return {};
  },
  mixins: [getData],
  computed: {
    ...mapGetters(["getAppStatus", "getAsset"])
  },
  methods: {
    incrementCounter(intValue) {
      // convert string to int
      // then increment by 1
      // then convert back to string
      let x = intValue;
      x = x + 1;
      return x;
    },
    decrementCounter(intValue) {
      // convert string to int
      // then minus by 1
      // then convert back to string
      let x = intValue;
      if (x > 0) {
        x = x - 1;
      }
      return x;
    },
    resetEnableSpinnerBtns() {
      this.enableSpinner = false;
      this.enableSpinner2 = false;
      this.enableSpinner3 = false;
    },
    readyp() {
      this.enableSpinner = true;
      this.getCompThenGoToCompReadPage(this.getUser.sel.cid);
    },
    readFacility() {
      this.enableSpinner2 = true;
      // console.log("readFacility()");
      // console.log(this.getUser.select.fname);
      this.getFacilityThenGoToFacilityReadPage(this.getUser.select.fname);
    },
    readSelectedAssetFromAssetsRegister(u) {
      // console.log(" Read Selected Asset ");
      // console.log(u);
      // this.loadingReadAsset = true;
      // assign pref for store
      this.barMovement = true;
      // this.enableSpinnerArray[n] = true;
      this.enableSpinner = true;
      let tempUser = this.getUser;
      tempUser.sel.aid = u.aid;
      tempUser.sel.an = u.an;
      this.$store.dispatch("changeUser", tempUser);
      this.readAsset();
    },
    readAsset() {
      this.enableSpinner3 = true;
      this.getAssetThenGoToAssetReadPage(this.getUser.sel.aid);
    },
    readAssetParent() {
      this.enableSpinner3 = true;
      this.getAssetThenGoToAssetReadPage(this.getAsset.struct.pAid);
    },
    createWorkFromAsset(ext) {
      this.$store.dispatch("changeWorkSelectedAsset", ext);
      this.$router.push("/worknew");
    }
  }
};
